import { USER_IDENTITY_API_URL } from 'src/modules/UserIdentity/constants/api';
import getApiClient from 'src/lib/getApiClient';
import apiRoutes from 'src/modules/UserIdentity/constants/apiRoutes';
import {
  AddFullIdentityStep2StatusResponse,
  ProcessId
} from 'src/modules/UserIdentity/types/api';

const getFullIdentityStep2Status = (processId: ProcessId) => {
  const apiClient = getApiClient(USER_IDENTITY_API_URL);

  return apiClient.get<AddFullIdentityStep2StatusResponse>(
    apiRoutes.fullIdentityStep2Status.replace('{processId}', processId)
  );
};

export default getFullIdentityStep2Status;
